import { axiosHelper } from 'Services/AxiosHelper';
import { OnCheckPhoneNumberModel } from 'Models';
import { onCreateOnlineCustomerBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnCreateOnlineCustomer';

const onCreateOnlineCustomer = async (params: onCreateOnlineCustomerBodyData): Promise<OnCheckPhoneNumberModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onCreateOnlineCustomer;
